import lazyWithRetry from 'tools/lazyWithRetry';

const component = lazyWithRetry(() => import(
	/* webpackChunkName: "StonecodeFileFileListPage" */
	'pages/file/StonecodeFileFile/StonecodeFileFileListPage'));

export default [{ component, exact: true, path: '/files' }];